import axios from "axios";
import router from '../../../router';

export default {

    async inventory_search(context, payload){

        const token = context.rootGetters.token;
        console.log('request for inventories');

        try{
            const responseData = await axios({
                method: 'post',
                url: process.env.VUE_APP_API_ENDPOINT+'inventory_search',
                data: {
                    term: payload.term,
                    limit: payload.limit,
                    offset: payload.offset,
                    conn_id: payload.conn_id
                },
                mode: 'no-cors',
                headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization' : token
                }
            })

            if(!responseData.data.success){
                context.commit('setRequestError', {message:responseData.data.message} );
            } else {
                context.commit('setRequestError', {message:''} );
                context.commit('setInventory', responseData.data.items);
            }

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }

    },

    async inventory(context, payload){

        const token = context.rootGetters.token;
        console.log('get inventory');

        try{
            const responseData = await axios({
                method: 'get',
                url: process.env.VUE_APP_API_ENDPOINT+'inventory/'+payload.id+'/'+payload.conn_id,
                mode: 'no-cors',
                headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization' : token
                }
            })

            if(!responseData.data.success){
                context.commit('setRequestError', {message:responseData.data.message} );
            } else {
                context.commit('setRequestError', {message:''} );
                context.commit('setSelectedInventory', responseData.data.result);
            }

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }

    }

}